import React from "react";
import { Link } from "react-router-dom";
import Nav from "../../component/Nav";
import Fab from "../../component/FAB";
import {
  IoMdAdd,
  IoIosArrowForward,
  IoIosTime,
  IoIosAlert,
  IoIosCheckmarkCircleOutline,
  IoIosPeople,
} from "react-icons/io";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import { FormatNumber, FormatDate } from "../../helpers";
import { useDebts, KIND_UTANG, KIND_PIUTANG } from "../../api";
import PartyList from "./PartyList";
import "./debt.css";

const initials = (name) =>
  (name || "?")
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const statusLabel = (s) =>
  ({
    open: "Belum",
    partial: "Cicilan",
    paid: "Lunas",
    overdue: "Telat",
    written_off: "Ditutup",
  }[s] || s);

const DebtCard = ({ d }) => {
  const pct = Math.min(
    100,
    Math.round((d.paidAmount / d.originalAmount) * 100) || 0
  );
  const kindClass = d.kind === KIND_UTANG ? "utang" : "piutang";
  return (
    <Link
      to={`/debts/${d.id}`}
      className={`debt-card debt-card--${d.status}`}
    >
      <div className="debt-card__row1">
        <div className="debt-card__party">
          <span
            className={`debt-card__party-avatar debt-card__party-avatar--${kindClass}`}
          >
            {initials(d.party.name)}
          </span>
          <span className="debt-card__party-name">{d.party.name}</span>
        </div>
        <span
          className={`debt-card__status debt-card__status--${d.status.replace(
            "_",
            "-"
          )}`}
        >
          {statusLabel(d.status)}
        </span>
      </div>
      <div className="debt-card__amount">
        Rp {FormatNumber(Math.round(d.outstanding))}
        <small>
          dari Rp {FormatNumber(Math.round(d.originalAmount))}
        </small>
      </div>
      <div className="debt-card__progress">
        <div
          className="debt-card__progress-bar"
          style={{ width: pct + "%" }}
        />
      </div>
      <div className="debt-card__meta">
        <span>{d.description || "—"}</span>
        {d.dueDate && (
          <span
            className={`debt-card__meta-due ${
              d.daysOverdue ? "debt-card__meta-due--overdue" : ""
            }`}
          >
            {d.daysOverdue ? (
              <>
                <IoIosAlert /> Telat {d.daysOverdue} hari
              </>
            ) : (
              <>
                <IoIosTime /> {FormatDate(d.dueDate)}
              </>
            )}
          </span>
        )}
      </div>
    </Link>
  );
};

const DebtList = (props) => {
  const [tab, setTab] = React.useState(
    () => localStorage.getItem("debtTab") || "utang"
  );
  const kind = tab === "piutang" ? KIND_PIUTANG : KIND_UTANG;
  const { debts, isLoading } = useDebts({ kind });

  // counts for tabs (fetch all kinds once)
  const { debts: utangAll } = useDebts({ kind: KIND_UTANG });
  const { debts: piutangAll } = useDebts({ kind: KIND_PIUTANG });
  const utangOpen = utangAll.filter((d) =>
    ["open", "partial", "overdue"].includes(d.status)
  ).length;
  const piutangOpen = piutangAll.filter((d) =>
    ["open", "partial", "overdue"].includes(d.status)
  ).length;

  const onTab = (t) => {
    setTab(t);
    localStorage.setItem("debtTab", t);
  };

  return (
    <>
      <Nav title="Utang & Piutang" icon={IoIosCheckmarkCircleOutline} />
      <div className="main-padding">
        <div
          className="debt-tabs"
          style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
        >
          <button
            className={`debt-tab ${tab === "utang" ? "debt-tab--active" : ""}`}
            onClick={() => onTab("utang")}
          >
            <FiArrowUpRight /> Utang
            {utangOpen > 0 && (
              <span className="debt-tab__count">{utangOpen}</span>
            )}
          </button>
          <button
            className={`debt-tab ${
              tab === "piutang" ? "debt-tab--active" : ""
            }`}
            onClick={() => onTab("piutang")}
          >
            <FiArrowDownLeft /> Piutang
            {piutangOpen > 0 && (
              <span className="debt-tab__count">{piutangOpen}</span>
            )}
          </button>
          <button
            className={`debt-tab ${tab === "parties" ? "debt-tab--active" : ""}`}
            onClick={() => onTab("parties")}
          >
            <IoIosPeople /> Counterparty
          </button>
        </div>

        {tab === "parties" ? (
          <PartyList />
        ) : (
          <>
            {isLoading && <p className="text-center text-muted">Memuat…</p>}

            {!isLoading && debts.length === 0 && (
              <div className="debt-empty">
                <IoIosCheckmarkCircleOutline className="debt-empty__icon" />
                <div className="debt-empty__title">
                  Belum ada {tab === "utang" ? "utang" : "piutang"}
                </div>
                <p className="debt-empty__sub">
                  Tap tombol <strong>+</strong> untuk catat yang pertama.
                </p>
              </div>
            )}

            {!isLoading && debts.map((d) => <DebtCard d={d} key={d.id} />)}
          </>
        )}
      </div>

      {tab !== "parties" && (
        <Fab
          icon={IoMdAdd}
          onClick={() => props.history.push("/debts/add?kind=" + kind)}
        />
      )}
    </>
  );
};

export default DebtList;
